import { FormHelperText, TextField } from '@material-ui/core';

export const ExistingFacilityName = ({ onChange, ...extraProps }) => {
  const showError =
    extraProps.value &&
    extraProps.existingfacilities &&
    extraProps.existingfacilities.some(
      name => name.trim().toLowerCase() === extraProps.value.trim().toLowerCase(),
    );
  return (
    <>
      <TextField id={extraProps.id || extraProps.name} onChange={onChange} {...extraProps} />
      {showError && (
        <FormHelperText key={'nameExists'} error>
          Facility name already exists
        </FormHelperText>
      )}
    </>
  );
};
